import React from 'react';
import './sub1.css';
import { Helmet } from 'react-helmet';
import contactConfig from '../../confi';

export default function Housemaid() {
  // Service data
  const services = [
    {
      id: 1,
      title: "Regular House Cleaning",
      description: "Professional daily or weekly cleaning service to maintain your home's cleanliness and hygiene.",
      features: [
        "Dusting and wiping all surfaces",
        "Floor sweeping and mopping",
        "Bathroom sanitization",
        "Kitchen cleaning",
        "Trash disposal"
      ],
      image: "https://images.unsplash.com/photo-1581578731548-c64695cc6952?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&h=400&q=80",
      icon: "🧹"
    },
    {
      id: 2,
      title: "Deep Cleaning Service",
      description: "Thorough cleaning service for move-in/move-out or seasonal deep cleaning needs.",
      features: [
        "Inside cabinet cleaning",
        "Appliance deep cleaning",
        "Window cleaning",
        "Wall wiping",
        "Grout and tile cleaning"
      ],
      image: "https://images.unsplash.com/photo-1556228453-efd6c1ff04f6?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&h=400&q=80",
      icon: "✨"
    },
    {
      id: 3,
      title: "Laundry & Ironing",
      description: "Complete laundry service including washing, drying, folding, and ironing.",
      features: [
        "Clothes washing & drying",
        "Ironing and steaming",
        "Folding and organizing",
        "Special fabric care",
        "Wardrobe organization"
      ],
      image: "https://images.unsplash.com/photo-1582735689369-4fe89db7114c?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&h=400&q=80",
      icon: "👔"
    },
    {
      id: 4,
      title: "Cooking & Meal Prep",
      description: "Healthy and delicious meal preparation service for busy families and individuals.",
      features: [
        "Meal planning",
        "Grocery shopping",
        "Cooking fresh meals",
        "Food storage",
        "Kitchen cleanup"
      ],
      image: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&h=400&q=80",
      icon: "🍳"
    },
    {
      id: 5,
      title: "Elderly Care",
      description: "Compassionate care and assistance for elderly family members at home.",
      features: [
        "Personal care assistance",
        "Medication reminders",
        "Companionship",
        "Light exercise support",
        "Safety monitoring"
      ],
      image: "https://images.unsplash.com/photo-1577896851231-70ef18881754?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&h=400&q=80",
      icon: "👵"
    },
    {
      id: 6,
      title: "Child Care Support",
      description: "Reliable childcare assistance including supervision and educational activities.",
      features: [
        "Child supervision",
        "Homework help",
        "Educational activities",
        "Meal preparation for kids",
        "Light child-related cleaning"
      ],
      image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSlYictK3tsM2jCwCe-dtbJyzMfFFL2d3Y0sA&s",
      icon: "👶"
    }
  ];

  const whyChooseUs = [
    {
      title: "Verified & Background Checked",
      description: "Every maid undergoes police verification and document screening before joining.",
      icon: "✅"
    },
    {
      title: "Trained & Professional",
      description: "Our maids receive practical training in housekeeping, hygiene, and etiquette.",
      icon: "🎓"
    },
    {
      title: "Flexible Scheduling",
      description: "Choose from hourly, daily, or monthly service options to suit your home routine.",
      icon: "⏰"
    },
    {
      title: "Replacement Guarantee",
      description: "Immediate replacement if you're not satisfied — no questions asked.",
      icon: "🔄"
    }
  ];

  const serviceFeatures = [
    {
      icon: "🧹",
      text: "Daily housekeeping (sweeping, mopping, dusting)"
    },
    {
      icon: "👕",
      text: "Utensil and laundry cleaning"
    },
    {
      icon: "✨",
      text: "Deep cleaning (kitchen, bathrooms, bedrooms)"
    },
    {
      icon: "👔",
      text: "Ironing and wardrobe organization"
    },
    {
      icon: "🏠",
      text: "Household management assistance"
    },
    {
      icon: "🎉",
      text: "Festive and occasion-based cleaning"
    }
  ];

  const processSteps = [
    {
      step: "1",
      title: "Tell Us Your Requirement",
      description: "Share your cleaning or household needs (part-time/full-time/live-in)"
    },
    {
      step: "2",
      title: "Receive Shortlisted Profiles",
      description: "We send you verified profiles of maids matching your criteria"
    },
    {
      step: "3",
      title: "Interview & Select",
      description: "You can interview candidates personally to ensure the right fit"
    },
    {
      step: "4",
      title: "Start Service",
      description: "The maid begins service as per your schedule"
    },
    {
      step: "5",
      title: "After-Support",
      description: "Full customer support and replacement options if required"
    }
  ];

  const testimonials = [
    {
      name: "Dr. Priya Mehta",
      location: "Bodakdev, Ahmedabad",
      rating: "⭐⭐⭐⭐⭐",
      text: "I've been using JP Home Services for over a year now. The maid they provided is punctual, polite, and maintains excellent hygiene. Truly professional service."
    },
    {
      name: "Mr. Ketan Shah",
      location: "Surat",
      rating: "⭐⭐⭐⭐⭐",
      text: "Finding a reliable maid in Surat was tough, but JP Home Services made it easy. Their team understood my needs and sent the perfect person within a day."
    },
    {
      name: "Mrs. Rupal Desai",
      location: "Vadodara",
      rating: "⭐⭐⭐⭐⭐",
      text: "Their staff are well-trained and trustworthy. I highly recommend JP Home Services to any working family looking for stress-free maid services."
    }
  ];

  const cities = [
    "Ahmedabad", "Surat", "Vadodara", "Rajkot", "Gandhinagar", "Anand", "Bhavnagar", "Jamnagar"
  ];
  const handleCall = () => {
    window.open(`tel:${contactConfig.phone}`);
  };

  const handleWhatsApp = () => {
    const phoneNumber = `${contactConfig.phone}`;
    const message = 'Hello, I would like to know more about your services.';
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <>
      <Helmet>
        <title>Hire Best House Maid Service in Ahmedabad - JP Home Services</title>
        <meta
          name="description"
          content="JP Home Services offers trusted house maid service in Ahmedabad with verified full-time and part-time work with daily home care. Call +91 9328843812."
        />
        <meta
          name="keywords"
          content="home services Ahmedabad, maid service, cook service, babysitter, caretaker, home care services, JP Home Services"
        />
        <meta property="og:title" content="Hire Best House Maid Service in Ahmedabad - JP Home Services" />
        <meta property="og:description" content="JP Home Services offers trusted house maid service in Ahmedabad with verified full-time and part-time work with daily home care. Call +91 9328843812." />
        <meta property="og:image" content="https://jphomeservice.in/static/media/TRANSPARNT%20LOGO.1a150556bfeacec71cee.png" />
        <meta property="og:url" content="https://jphomeservice.in/house-maid-services-in-ahmedabad" />
        <meta property="og:site_name" content="JP Home Services" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@" />
        <meta name="twitter:title" content="Hire Best House Maid Service in Ahmedabad - JP Home Services" />
        <meta name="twitter:description" content="JP Home Services offers trusted house maid service in Ahmedabad with verified full-time and part-time work with daily home care. Call +91 9328843812." />
        <meta name="twitter:image" content="https://jphomeservice.in/static/media/TRANSPARNT%20LOGO.1a150556bfeacec71cee.png" />
        <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
        <link rel="canonical" href="https://jphomeservice.in/house-maid-services-in-ahmedabad" />
        {/* JSON-LD Structured Data */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "WebPage",
              "@id": "https://jphomeservice.in/house-maid-services-in-ahmedabad#webpage",
              "url": "https://jphomeservice.in/house-maid-services-in-ahmedabad",
              "name": "Hire Best Home Maid Services in Ahmedabad - JP Home Services",
              "description": "JP Home Services offers trusted house maid service in Ahmedabad with verified full-time and part-time house maids for daily home care. Call now to hire!",
              "inLanguage": "en-IN",
              "isPartOf": {
                "@type": "WebSite",
                "@id": "https://jphomeservice.in/#website",
                "name": "JP Home Services",
                "url": "https://jphomeservice.in/"
              },
              "publisher": {
                "@type": "Organization",
                "@id": "https://jphomeservice.in/#organization",
                "name": "JP Home Services",
                "url": "https://jphomeservice.in/"
              }
            }
          `}
        </script>
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "LocalBusiness",
              "name": "Home Maid Service in Ahmedabad",
              "image": "https://jphomeservice.in/static/media/TRANSPARNT%20LOGO.1a150556bfeacec71cee.png",
              "@id": "",
              "url": "https://jphomeservice.in/house-maid-services-in-ahmedabad",
              "telephone": "+919327365056",
              "priceRange": "₹₹",
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "A-316-317, Swaminarayan Avenue,  Nr. AEC Cross Road, Naranpura",
                "addressLocality": "Ahmedabad, Gujarat",
                "postalCode": "380013",
                "addressCountry": "IN"
              },
              "geo": {
                "@type": "GeoCoordinates",
                "latitude": 23.0542109,
                "longitude": 72.5482134
              },
              "openingHoursSpecification": {
                "@type": "OpeningHoursSpecification",
                "dayOfWeek": [
                  "Monday",
                  "Tuesday",
                  "Wednesday",
                  "Thursday",
                  "Friday",
                  "Saturday",
                  "Sunday"
                ],
                "opens": "00:00",
                "closes": "23:59"
              },
              "sameAs": [
                "https://www.facebook.com/jphomeservice.in/",
                "https://www.instagram.com/jp_home_service/"
              ] 
            }
          `}
        </script>
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "Service",
            "name": "House Maid Services in Ahmedabad",
            "serviceType": "House Maid Services",
            "description": "JP Home Service provides reliable house maid services in Ahmedabad for household cleaning, cooking, and daily home assistance.",
            "url": "https://jphomeservice.in/house-maid-services-in-ahmedabad",
            "areaServed": {
              "@type": "City",
              "name": "Ahmedabad"
            },
            "provider": {
              "@type": "Organization",
              "name": "JP Home Service",
              "url": "https://jphomeservice.in/"
            }
          }
          `}
        </script>
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org/", 
            "@type": "BreadcrumbList", 
            "itemListElement": [{
              "@type": "ListItem", 
              "position": 1, 
              "name": "Home",
              "item": "https://jphomeservice.in"  
            },{
              "@type": "ListItem", 
              "position": 2, 
              "name": "Home Maid Services in Ahmedabad",
              "item": "https://jphomeservice.in/house-maid-services-in-ahmedabad"  
            }]
          }
          `}
        </script>
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@graph": [
              {
                "@type": "Review",
                "@id": "https://jphomeservice.in/house-maid-services-in-ahmedabad#review-priya-mehta",
                "url": "https://jphomeservice.in/house-maid-services-in-ahmedabad",
                "itemReviewed": {
                  "@type": "Organization",
                  "name": "JP Home Service",
                  "url": "https://jphomeservice.in/"
                },
                "author": {
                  "@type": "Person",
                  "name": "Dr. Priya Mehta"
                },
                "reviewRating": {
                  "@type": "Rating",
                  "ratingValue": 5,
                  "bestRating": 5,
                  "worstRating": 1
                },
                "reviewBody": "I've been using JP Home Services for over a year now. The maid they provided is punctual, polite, and maintains excellent hygiene. Truly professional service."
              },
              {
                "@type": "Review",
                "@id": "https://jphomeservice.in/house-maid-services-in-ahmedabad#review-ketan-shah",
                "url": "https://jphomeservice.in/house-maid-services-in-ahmedabad",
                "itemReviewed": {
                  "@type": "Organization",
                  "name": "JP Home Service",
                  "url": "https://jphomeservice.in/"
                },
                "author": {
                  "@type": "Person",
                  "name": "Mr. Ketan Shah"
                },
                "reviewRating": {
                  "@type": "Rating",
                  "ratingValue": 5,
                  "bestRating": 5,
                  "worstRating": 1
                },
                "reviewBody": "Finding a reliable maid in Surat was tough, but JP Home Services made it easy. Their team understood my needs and sent the perfect person within a day."
              },
              {
                "@type": "Review",
                "@id": "https://jphomeservice.in/house-maid-services-in-ahmedabad#review-rupal-desai",
                "url": "https://jphomeservice.in/house-maid-services-in-ahmedabad",
                "itemReviewed": {
                  "@type": "Organization",
                  "name": "JP Home Service",
                  "url": "https://jphomeservice.in/"
                },
                "author": {
                  "@type": "Person",
                  "name": "Mrs. Rupal Desai"
                },
                "reviewRating": {
                  "@type": "Rating",
                  "ratingValue": 5,
                  "bestRating": 5,
                  "worstRating": 1
                },
                "reviewBody": "Their staff are well-trained and trustworthy. I highly recommend JP Home Services to anyone looking for stress-free maid services."
              },
              {
                "@type": "AggregateRating",
                "@id": "https://jphomeservice.in/house-maid-services-in-ahmedabad#aggregate-rating",
                "itemReviewed": {
                  "@type": "Organization",
                  "name": "JP Home Service",
                  "url": "https://jphomeservice.in/"
                },
                "ratingValue": 5,
                "bestRating": 5,
                "worstRating": 1,
                "reviewCount": 3
              }
            ]
          }
          `}
        </script>
      </Helmet>
      <div className="main-content-wrapper">
        {/* Hero Section */}
        <section className="housemaid-hero-section">
          <div className="container">
            <div className="housemaid-hero-content">
              <h1>🧹 Home Maid Services in Ahmedabad, Surat & Major Cities of Gujarat</h1>
              <p><strong>Reliable, Trained & Verified Maids for Your Home</strong></p>
              <p>Managing a household requires care, consistency, and attention to detail — and that's exactly what JP Home Services delivers. We provide professional home maid services in Ahmedabad, Surat, Vadodara, Rajkot, and other major cities of Gujarat, helping families find dependable and well-trained domestic staff who make daily living effortless.</p>
              <p>Our maids are not just helpers — they are trusted home partners, dedicated to keeping your home clean, organized, and welcoming.</p>
              <div className="hero-stats">
                <div className="stat-item">
                  <span>1000+</span>
                  <p>Happy Families</p>
                </div>
                <div className="stat-item">
                  <span>100%</span>
                  <p>Verified Staff</p>
                </div>
                <div className="stat-item">
                  <span>24/7</span>
                  <p>Customer Support</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Service Features Section */}
        <section className="service-features-section">
          <div className="container">
            <div className="section-header1">
              <h2>🧺 Our Home Maid Service Features</h2>
              <p>At JP Home Services, every maid is carefully selected, trained, and verified before placement. We ensure our staff meets the highest standards of hygiene, efficiency, and reliability.</p>
            </div>

            <div className="features-grid">
              {serviceFeatures.map((feature, index) => (
                <div key={index} className="feature-item">
                  <div className="feature-icon1">{feature.icon}</div>
                  <span>{feature.text}</span>
                </div>
              ))}
            </div>

            <div className="flexibility-note">
              <p><strong>Choose flexibility</strong> — part-time, full-time, or live-in maid services — as per your convenience.</p>
            </div>
          </div>
        </section>

        {/* Why Choose Us Section */}
        <section className="why-choose-section">
          <div className="container">
            <div className="section-header">
              <h2> Why Choose Maids from JP Home Services</h2>
              <p>Finding a trustworthy maid can be challenging — and that's where our expertise stands out. Here's why families across Gujarat choose JP Home Services:</p>
            </div>

            <div className="features-grid">
              {whyChooseUs.map((feature, index) => (
                <div key={index} className="feature-card">
                  <div className="feature-icon1">{feature.icon}</div>
                  <h3>{feature.title}</h3>
                  <p>{feature.description}</p>
                </div>
              ))}
            </div>

            <div className="additional-benefits">
              <div className="benefit-item">
                <span className="check-icon">✓</span>
                <span className="p">Personalized Matching - We match maids to your specific household needs and preferences</span>
              </div>
              <div className="benefit-item">
                <span className="check-icon">✓</span>
                <span className="p">Reliable Support Team - Our customer support ensures smooth communication and timely follow-ups</span>
              </div>
            </div>

            <div className="trust-note">
              <p><strong>We value your trust — and we work hard every day to protect it.</strong></p>
            </div>
          </div>
        </section>

        <div className="floating-contact-icons">
          <div className="contact-icon whatsapp-icon" onClick={handleWhatsApp}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893c0-3.18-1.24-6.169-3.495-8.424" />
            </svg>
          </div>
          <div
            className="contact-icon call-icon"
            onClick={handleCall}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
              <path d="M20 10.999h2C22 5.869 18.127 2 12.99 2v2C17.052 4 20 6.943 20 10.999z" />
              <path d="M13 8c2.103 0 3 .897 3 3h2c0-3.225-1.775-5-5-5v2zm3.422 5.443a1.001 1.001 0 00-1.391.043l-2.393 2.461c-.576-.11-1.734-.471-2.926-1.66-1.192-1.193-1.553-2.354-1.66-2.926l2.459-2.394a1 1 0 00.043-1.391L6.859 3.513a1 1 0 00-1.391-.087l-2.17 1.861a1 1 0 00-.29.649c-.015.25-.301 6.172 4.291 10.766C11.305 20.707 16.323 21 17.705 21c.202 0 .326-.006.359-.008a.992.992 0 00.648-.291l1.86-2.171a1 1 0 00-.086-1.391l-4.064-3.696z" />
            </svg>
          </div>
        </div>

        {/* How It Works Section */}
        <section className="process-section">
          <div className="container">
            <div className="section-header1">
              <h2>How Our Service Works</h2>
              <p>We make the process of hiring a home maid simple, safe, and transparent.</p>
            </div>

            <div className="process-steps">
              {processSteps.map((step, index) => (
                <div key={index} className="process-step">
                  <div className="step-number">{step.step}</div>
                  <div className="step-content">
                    <h3>{step.title}</h3>
                    <p>{step.description}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="process-conclusion">
              <p><strong>From selection to satisfaction — we handle everything for you.</strong></p>
            </div>
          </div>
        </section>

        {/* Testimonials Section */}
        <section className="testimonials-section">
          <div className="container">
            <div className="section-header1">
              <h2>What Our Customers Say</h2>
            </div>

            <div className="testimonials-grid">
              {testimonials.map((testimonial, index) => (
                <div key={index} className="testimonial-card">
                  <div className="testimonial-rating">{testimonial.rating}</div>
                  <p className="testimonial-text">"{testimonial.text}"</p>
                  <div className="testimonial-author">
                    <strong>{testimonial.name}</strong>
                    <span>{testimonial.location}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Benefits Section */}
        <section className="benefits-section">
          <div className="container">
            <div className="section-header1">
              <h2>Benefits of Choosing JP Home Services</h2>
              <p>When you choose JP Home Services, you're not just hiring a maid — you're investing in peace of mind and professional care.</p>
            </div>

            <div className="benefits-grid">
              <div className="benefit-item-large">
                <span className="check-icon">✓</span>
                <span>Professionally trained and verified staff</span>
              </div>
              <div className="benefit-item-large">
                <span className="check-icon">✓</span>
                <span>Transparent pricing with no hidden charges</span>
              </div>
              <div className="benefit-item-large">
                <span className="check-icon">✓</span>
                <span>100% satisfaction and replacement guarantee</span>
              </div>
              <div className="benefit-item-large">
                <span className="check-icon">✓</span>
                <span>Dedicated customer support team</span>
              </div>
              <div className="benefit-item-large">
                <span className="check-icon">✓</span>
                <span>Available across Ahmedabad, Surat, Vadodara, Rajkot, and Gandhinagar</span>
              </div>
              <div className="benefit-item-large">
                <span className="check-icon">✓</span>
                <span>Trusted by hundreds of premium households across Gujarat</span>
              </div>
            </div>

            <div className="brand-tagline">
              <p><strong>Clean homes. Peaceful minds. Trusted service — that's JP Home Services.</strong></p>
            </div>
          </div>
        </section>

        {/* Service Coverage Section */}
        <section className="coverage-section">
          <div className="container">
            <div className="section-header">
              <h2>Service Coverage</h2>
              <p>We proudly serve clients across major cities in Gujarat:</p>
            </div>

            <div className="cities-grid">
              {cities.map((city, index) => (
                <div key={index} className="city-item">
                  {city}
                </div>
              ))}
            </div>

            <div className="coverage-note">
              <p><strong>No matter where you live, JP Home Services ensures reliable domestic help is just a call away.</strong></p>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="housemaid-cta-section">
          <div className="container">
            <div className="cta-content">
              <h2>Ready to Experience Professional Home Care?</h2>
              <p>Contact us today to find your perfect home maid match</p>
              <div className="cta-buttons1">
                <button
                  className="cta-btn1 secondary23 assistant-btn"
                  onClick={() => {
                    const number = `${contactConfig.phone}`;
                    window.history.pushState({}, "", `/call/${number}`);
                    if (window.gtag) {
                      window.gtag("event", "conversion", {
                        send_to: "AW-16629382441/EFuzCL_s9cIbEKn6wPk9",
                      });
                    }
                    setTimeout(() => {
                      window.location.href = `tel:${number}`;
                    }, 600);
                  }}
                >
                  Call Now: {contactConfig.phone}
                </button>
              </div>

            </div>
          </div>
        </section>
      </div>
    </>
  );
} 